import React, { useState, useEffect } from 'react';
import { IonImg, IonLabel } from '@ionic/react';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';

import './RadiusRange.scss';

interface RadiusRangeProps {
  labelName: string;
  InputValue: number;
  name: string;
  handleChange: any;
  className: string;
  rangeDisabled: boolean;
}

export const RadiusRange: React.FC<RadiusRangeProps> = (props: RadiusRangeProps) => {
  const { labelName, InputValue, handleChange, name, className, rangeDisabled } = props;
  const [selectedValue, setSelectedValue] = useState<number>(InputValue || 25);

  const SliderWithTooltip = createSliderWithTooltip(Slider);

  const valueFormatter = (v: any) => {
    return `${v} mi`;
  };

  const marks = {
    25: '25mi',
    50: '50mi',
    75: '',
    100: '100mi',
    125: '',
    150: '150mi',
    175: '',
    200: '200mi',
    225: '',
    250: '250mi'
  };

  const onValueChnage = (value: number) => {
    setSelectedValue(value);
    const event = { target: { name, value } };
    handleChange(event);
  };

  useEffect(() => {
    setSelectedValue(InputValue);
  }, [InputValue]);

  const onClickPlus = () => {
    setSelectedValue(selectedValue + 25);
    const event = { target: { name, value: selectedValue + 25 } };
    handleChange(event);
  };
  const onClickMinus = () => {
    setSelectedValue(selectedValue - 25);
    const event = { target: { name, value: selectedValue - 25 } };
    handleChange(event);
  };

  return (
    <div className={`radius-range ${rangeDisabled && 'range-disabled'} ${className}`}>
      <div className="radius-range-control" data-testid="radiusRange">
        <div className="radius-text">
          <p className="radius-label">
            {labelName}
          </p>
          <IonLabel mode="ios" className={`radius-range-label ${rangeDisabled ? 'range-label-disabled' : ''}`}>
            {selectedValue}mi
          </IonLabel>
        </div>
        <SliderWithTooltip
          min={25}
          marks={marks}
          step={25}
          max={250}
          onChange={onValueChnage}
          tipFormatter={valueFormatter}
          value={selectedValue}
          disabled={rangeDisabled}
        />
        <div className="divider"></div>
      </div>
      <div className="radius-range-actions">
        <IonImg
          className={`plus ${(selectedValue >= 250 || rangeDisabled) && 'disabled'}`}
          data-testid="plus"
          src="assets/icon/capacity-plus-icon.svg"
          onClick={() => {
            if (!(selectedValue >= 250 || rangeDisabled)) {
              onClickPlus();
            }
          }}
        />
        <IonLabel mode="ios" className="radius-range-label">
          {selectedValue}
        </IonLabel>
        <IonImg
          className={`minus ${(selectedValue <= 25 || rangeDisabled) && 'disabled'}`}
          src="assets/icon/capacity-minus-icon.svg"
          data-testid="minus"
          onClick={() => {
            if (!(selectedValue <= 25 || rangeDisabled)) {
              onClickMinus();
            }
          }}
        />
      </div>
    </div>
  );
};
